<mat-toolbar class="header-content">
    <div class="header-title">
        <mat-icon>settings</mat-icon>
        {{ titleKey | translate }}
    </div>
</mat-toolbar>

<mat-dialog-content>
    <p>{{ messageKey | translate: { count: data.count } }}</p>

    <p *ngIf="data.allowSame === false">{{'trackers.configure_selection_mixed_types'|translate}}</p>

    <div class="choice-actions">
        <lib-button *ngIf="data.allowSame !== false" color="primary" icon="content_copy"
            text="{{'trackers.configure_new_kyds_same'|translate}}" (click)="choose('same')"></lib-button>
        <lib-button color="secondary" icon="edit_note" text="{{'trackers.configure_new_kyds_each'|translate}}"
            (click)="choose('each')"></lib-button>
        <lib-button color="none" textColor="muted" text="{{cancelKey|translate}}"
            (click)="choose(null)"></lib-button>
    </div>
</mat-dialog-content>
